var TabReallocateMaintenanceModule = /** @class */ (function () {
    function TabReallocateMaintenanceModule() {
    }
    return TabReallocateMaintenanceModule;
}());
export { TabReallocateMaintenanceModule };
